<template>
	<section class="dp-layout">
		<section class="dp-left">
			<DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
		</section>
		<section class="dp-right">
			<div class="department-info">
				<span>所属机构：</span>
				<span>{{ currentDepartmentName || '全部' }}</span>
			</div>

			<div class="toolbar-filter-bar">
				<el-form :inline="true" class="toolbar-filter-form">
					<div class="toolbar-filter-fields">
						<el-form-item>
							<el-input v-model="queryParams.studentNo" placeholder="学号" class="toolbar-field-w-md"
								clearable @keyup.enter.native="queryMoralScore" />
						</el-form-item>
						<el-form-item>
							<el-input v-model="queryParams.stuName" placeholder="姓名" class="toolbar-field-w-md"
								clearable @keyup.enter.native="queryMoralScore" />
						</el-form-item>
						<el-form-item>
							<el-input v-model="queryParams.cardNo" placeholder="卡号" class="toolbar-field-w-md"
								clearable @keyup.enter.native="queryMoralScore" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" size="small" icon="el-icon-search" :loading="loading" @click="queryMoralScore">查询</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>

			<div v-if="showResult" class="result-section">
				<el-card class="result-card" shadow="never">
					<div slot="header" class="card-header">
						<span>查询结果 — {{ moralScoreResult.name || '-' }}</span>
					</div>

					<el-tabs v-model="activeTab" class="result-tabs" @tab-click="handleTabClick">
						<el-tab-pane label="德育分" name="moral">
							<div class="tab-pane-body">
								<div class="summary-row">
									<div class="stat-board">
										<div class="board-item board-earn">
											<div class="board-label">本学期加分</div>
											<div class="board-value">{{ moralScoreResult.semesterEarnScore }}</div>
										</div>
										<div class="board-item board-pending">
											<div class="board-label">待转分</div>
											<div class="board-value">{{ moralScoreResult.pendingConvertScore }}</div>
										</div>
									</div>
									<div class="board-tip">
										本学期加分用于评优；待转分为尚未结转进商城的德育分（日结后归零属正常）。结转行可看「转入积分」列。
									</div>
								</div>

								<div class="section-title">变动明细</div>
								<!-- tbl-scroll-host：表体占满剩余高度并内滚。最后更新：2026-09-23 -->
								<div class="tbl-scroll-host">
									<el-table :data="moralDetails" height="100%" style="width: 100%"
										:row-class-name="moralRowClassName">
										<el-table-column prop="Date" label="日期" width="170"></el-table-column>
										<el-table-column prop="SourceTypeName" label="类型" width="120">
											<template slot-scope="scope">
												<span>{{ scope.row.SourceTypeName || scope.row.sourceTypeName || '-' }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="Reason" label="记分原因" min-width="180" show-overflow-tooltip></el-table-column>
										<el-table-column label="德育分" width="100">
											<template slot-scope="scope">
												<span :class="scoreClass(scope.row.Score)">{{ formatSigned(scope.row.Score) }}</span>
											</template>
										</el-table-column>
										<el-table-column label="转入积分" width="100">
											<template slot-scope="scope">
												<span v-if="scope.row.ConvertedPoints != null || scope.row.convertedPoints != null"
													class="score-pos">
													{{ formatSigned(scope.row.ConvertedPoints != null ? scope.row.ConvertedPoints : scope.row.convertedPoints) }}
												</span>
												<span v-else class="muted">-</span>
											</template>
										</el-table-column>
										<el-table-column prop="Initiator" label="发起人" width="140" show-overflow-tooltip></el-table-column>
									</el-table>
								</div>
								<div class="pagination-container">
									<el-pagination background layout="total, prev, pager, next, jumper, sizes"
										:total="detailPagination.moralTotal" :current-page="detailPagination.moralPage"
										:page-sizes="[10, 20, 50, 100]" :page-size="detailPagination.moralPageSize"
										@current-change="handleMoralCurrentChange" @size-change="handleMoralSizeChange" />
								</div>
							</div>
						</el-tab-pane>

						<el-tab-pane label="商城积分" name="points">
							<div class="tab-pane-body">
								<div class="summary-row">
									<div class="stat-board">
										<div class="board-item board-converted">
											<div class="board-label">已转分（德育侧）</div>
											<div class="board-value">{{ moralScoreResult.exchangedScore }}</div>
										</div>
										<div class="board-item board-points">
											<div class="board-label">可用商城积分</div>
											<div class="board-value">{{ moralScoreResult.consumptionPointsAvailable }}</div>
										</div>
									</div>
									<div class="board-tip">
										已转分为历史从德育分结转出的量；可用商城积分可兑奖（兑过奖后会小于已转分）。明细与家长端积分流水同源。
									</div>
								</div>

								<div class="section-title">变动明细</div>
								<div class="tbl-scroll-host">
									<el-table :data="pointDetails" height="100%" style="width: 100%">
										<el-table-column prop="bizTime" label="日期" width="170">
											<template slot-scope="scope">
												{{ scope.row.bizTime || scope.row.BizTime || '-' }}
											</template>
										</el-table-column>
										<el-table-column label="类型" width="140">
											<template slot-scope="scope">
												{{ scope.row.refTypeName || scope.row.RefTypeName || '-' }}
											</template>
										</el-table-column>
										<el-table-column label="积分" width="120">
											<template slot-scope="scope">
												<span :class="scoreClass(scope.row.deltaPoints != null ? scope.row.deltaPoints : scope.row.DeltaPoints)">
													{{ formatSigned(scope.row.deltaPoints != null ? scope.row.deltaPoints : scope.row.DeltaPoints) }}
												</span>
											</template>
										</el-table-column>
										<el-table-column label="说明" min-width="220" show-overflow-tooltip>
											<template slot-scope="scope">
												{{ scope.row.reason || scope.row.Reason || '-' }}
											</template>
										</el-table-column>
									</el-table>
								</div>
								<div class="pagination-container">
									<el-pagination background layout="total, prev, pager, next, jumper, sizes"
										:total="detailPagination.pointTotal" :current-page="detailPagination.pointPage"
										:page-sizes="[10, 20, 50, 100]" :page-size="detailPagination.pointPageSize"
										@current-change="handlePointCurrentChange" @size-change="handlePointSizeChange" />
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</div>
		</section>
	</section>
</template>

<script>
import DepartmentPane from '@/components/DepartmentPane.vue'
import { getMoralScoreSummary, getMoralScoreDetailPage, getMoralPointLedgerPage } from '../../api/modules/personnel'

export default {
	components: {
		DepartmentPane
	},
	data() {
		return {
			DepartmentId: '',
			currentDepartmentName: '',
			activeTab: 'moral',
			queryParams: {
				studentNo: '',
				stuName: '',
				cardNo: ''
			},
			showResult: false,
			moralScoreResult: {
				name: '',
				semesterEarnScore: 0,
				pendingConvertScore: 0,
				exchangedScore: 0,
				consumptionPointsAvailable: 0
			},
			moralDetails: [],
			pointDetails: [],
			pointLoaded: false,
			loading: false,
			detailPagination: {
				moralPage: 1,
				moralPageSize: 10,
				moralTotal: 0,
				pointPage: 1,
				pointPageSize: 10,
				pointTotal: 0
			}
		}
	},
	methods: {
		treeNodeClick(data) {
			this.DepartmentId = Number(data && (data.value || data.Id) || 0)
			this.currentDepartmentName = data.label || data.name || ''
		},

		/**
		 * 查询汇总；默认加载德育分明细，切到积分 Tab 时再加载积分流水
		 */
		async queryMoralScore() {
			if (!this.queryParams.studentNo && !this.queryParams.stuName && !this.queryParams.cardNo) {
				this.$message.warning('请输入学号、姓名或卡号进行查询')
				return
			}
			if (!this.DepartmentId) {
				this.$message.warning('请先选择左侧学校')
				return
			}

			this.loading = true
			try {
				const summaryParams = {
					DepartmentId: this.DepartmentId,
					studentNo: this.queryParams.studentNo,
					stuName: this.queryParams.stuName,
					cardNo: this.queryParams.cardNo
				}
				const summaryRes = await getMoralScoreSummary(summaryParams)
				if (!summaryRes.data.success) {
					this.$message.error(summaryRes.data.msg || '查询失败')
					return
				}

				this.moralScoreResult = summaryRes.data.response || {
					name: '',
					semesterEarnScore: 0,
					pendingConvertScore: 0,
					exchangedScore: 0,
					consumptionPointsAvailable: 0
				}
				this.showResult = true
				this.pointLoaded = false
				this.detailPagination.moralPage = 1
				this.detailPagination.pointPage = 1
				this.pointDetails = []

				await this.loadMoralDetails()
				if (this.activeTab === 'points') {
					await this.loadPointDetails()
				}
			} catch (error) {
				this.$message.error('查询失败')
				console.error(error)
			} finally {
				this.loading = false
			}
		},

		handleTabClick(tab) {
			const name = (tab && (tab.name || tab.paneName)) || this.activeTab
			if (name === 'points' && this.showResult && !this.pointLoaded) {
				this.loadPointDetails()
			}
		},

		buildQueryBase() {
			return {
				DepartmentId: this.DepartmentId,
				studentNo: this.queryParams.studentNo,
				stuName: this.queryParams.stuName,
				cardNo: this.queryParams.cardNo
			}
		},

		async loadMoralDetails() {
			try {
				const detailRes = await getMoralScoreDetailPage({
					...this.buildQueryBase(),
					page: this.detailPagination.moralPage,
					pageSize: this.detailPagination.moralPageSize
				})
				if (detailRes.data.success) {
					this.moralDetails = detailRes.data.response.data || []
					this.detailPagination.moralTotal = detailRes.data.response.dataCount || 0
				}
			} catch (error) {
				console.error('加载德育分明细失败:', error)
			}
		},

		async loadPointDetails() {
			try {
				const res = await getMoralPointLedgerPage({
					...this.buildQueryBase(),
					page: this.detailPagination.pointPage,
					pageSize: this.detailPagination.pointPageSize
				})
				if (res.data.success) {
					this.pointDetails = res.data.response.data || []
					this.detailPagination.pointTotal = res.data.response.dataCount || 0
					this.pointLoaded = true
				} else {
					this.$message.error(res.data.msg || '加载积分明细失败')
				}
			} catch (error) {
				console.error('加载积分明细失败:', error)
			}
		},

		handleMoralCurrentChange(val) {
			this.detailPagination.moralPage = val
			this.loadMoralDetails()
		},
		handleMoralSizeChange(val) {
			this.detailPagination.moralPageSize = val
			this.detailPagination.moralPage = 1
			this.loadMoralDetails()
		},
		handlePointCurrentChange(val) {
			this.detailPagination.pointPage = val
			this.loadPointDetails()
		},
		handlePointSizeChange(val) {
			this.detailPagination.pointPageSize = val
			this.detailPagination.pointPage = 1
			this.loadPointDetails()
		},

		formatSigned(val) {
			const n = Number(val)
			if (Number.isNaN(n)) return '-'
			if (n > 0) return '+' + n
			return String(n)
		},
		scoreClass(val) {
			const n = Number(val)
			if (n > 0) return 'score-pos'
			if (n < 0) return 'score-neg'
			return ''
		},
		moralRowClassName({ row }) {
			const t = row.SourceType || row.sourceType || ''
			return t === 'ConvertToPoints' ? 'row-convert' : ''
		}
	}
}
</script>

<style scoped>
.department-info {
	flex: 0 0 auto;
	margin-bottom: 12px;
	padding: 8px 12px;
	background-color: #f5f7fa;
	border-radius: 4px;
	font-size: 13px;
}

/* 结果区占满右栏剩余高度，把滚动交给表体 */
.result-section {
	flex: 1 1 auto;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	margin-bottom: 0;
}

.result-section ::v-deep .result-card.el-card {
	flex: 1 1 auto;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border: none;
}

.result-section ::v-deep .el-card__header {
	flex: 0 0 auto;
	padding: 12px 16px;
}

.result-section ::v-deep .el-card__body {
	flex: 1 1 auto;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 4px 16px 12px;
}

.card-header {
	display: flex;
	align-items: center;
	font-weight: 600;
}

.result-tabs {
	flex: 1 1 auto;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.result-section ::v-deep .result-tabs > .el-tabs__header {
	flex: 0 0 auto;
	margin-bottom: 10px;
}

.result-section ::v-deep .result-tabs > .el-tabs__content {
	flex: 1 1 auto;
	min-height: 0;
	overflow: hidden;
}

.result-section ::v-deep .result-tabs .el-tab-pane {
	height: 100%;
}

.tab-pane-body {
	height: 100%;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.summary-row {
	flex: 0 0 auto;
	display: flex;
	align-items: stretch;
	gap: 12px;
	margin-bottom: 12px;
}

.stat-board {
	display: flex;
	flex: 1 1 auto;
	min-width: 0;
	gap: 12px;
}

.board-item {
	flex: 1 1 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 12px 16px;
	border-radius: 8px;
	background: #f5f7fa;
	border: 1px solid #ebeef5;
}

.board-label {
	font-size: 13px;
	color: #909399;
	margin-bottom: 4px;
}

.board-value {
	font-size: 26px;
	font-weight: 700;
	line-height: 1.2;
}

.board-earn .board-value { color: var(--btn-primary, #2563eb); }
.board-pending .board-value { color: #67C23A; }
.board-converted .board-value { color: #606266; }
.board-points .board-value { color: #E6A23C; }

.board-tip {
	flex: 0 1 360px;
	max-width: 420px;
	font-size: 12px;
	line-height: 1.55;
	color: #909399;
	padding: 12px 14px;
	background: #fdf6ec;
	border-left: 3px solid #E6A23C;
	border-radius: 4px;
	display: flex;
	align-items: center;
}

.section-title {
	flex: 0 0 auto;
	font-size: 13px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 8px;
}

/* 嵌套在卡片内的 tbl-scroll-host：补齐高度链，表体内滚 */
.tab-pane-body > .tbl-scroll-host {
	flex: 1 1 auto;
	min-height: 0;
	height: 0;
	width: 100%;
	overflow: hidden;
}

.tab-pane-body > .tbl-scroll-host ::v-deep .el-table {
	width: 100%;
	height: 100%;
}

.tab-pane-body > .tbl-scroll-host ::v-deep .el-table__body-wrapper {
	overflow-y: auto !important;
}

.pagination-container {
	flex: 0 0 auto;
	margin-top: 10px;
	text-align: right;
}

.score-pos { color: #67C23A; font-weight: 600; }
.score-neg { color: #F56C6C; font-weight: 600; }
.muted { color: #c0c4cc; }

::v-deep .row-convert {
	background: #fafafa;
	color: #909399;
}

@media (max-width: 1100px) {
	.summary-row {
		flex-direction: column;
	}

	.board-tip {
		flex: none;
		max-width: none;
	}
}

@media (max-width: 768px) {
	.stat-board {
		flex-direction: column;
	}

	.tab-pane-body > .tbl-scroll-host {
		height: auto;
		min-height: 240px;
	}
}
</style>
